module.exports = __webpack_public_path__ + "img/7_8.16f4bbd8.png";